import { AxiosError, AxiosResponse } from 'axios';
import { useMutation, UseMutationResult, useQueryClient } from 'react-query';
import { AthletePackageUpdate, AthletePackageUpdateResponse, ErrorMessage } from 'types';
import { client } from 'utils/api-client';

export default function useUpdateAthletePackage(): UseMutationResult<
  AxiosResponse<AthletePackageUpdateResponse>,
  AxiosError<ErrorMessage>,
  AthletePackageUpdate
> {
  const queryClient = useQueryClient();

  const updateAthletePackage = (
    athletePackage: AthletePackageUpdate,
  ): Promise<AxiosResponse<AthletePackageUpdateResponse>> => {
    return client.put(`athlete-packages/${athletePackage.athletePackageId}/`, athletePackage);
  };

  return useMutation(updateAthletePackage, {
    onSuccess: () => {
      // Prefix invalidation, so this covers both the packages list and the detail query for every
      // package in the chain the auto-pay and payment-method actions now write, not just the one
      // the modal was opened from.
      queryClient.invalidateQueries(['athletePackages']);
    },
  });
}
